// Contenido del Acuerdo de Mentoría — texto exacto de la referencia (mitsui.html?v=2).

export interface PolicyBlock {
  type: 'text' | 'emphasis' | 'small' | 'list';
  content?: string;
  label?: string;
  items?: string[];
}
export interface PolicySection { id: string; num: string; kicker: string; title: string; blocks: PolicyBlock[]; }
export interface AgreementQuestion { id: string; text: string; helper: string; }

export const POLICY_SECTIONS: PolicySection[] = [
  {
    id: 'p1', num: '01', kicker: 'PROPÓSITO', title: 'Propósito',
    blocks: [
      { type: 'text', content: 'Este es un espacio de desarrollo. El mentor aporta experiencia y perspectiva; el mentee define qué quiere trabajar y conduce su propio proceso. El valor está en la conversación. Este sistema existe para sostener el proceso, no para auditarlo.' },
    ],
  },
  {
    id: 'p2', num: '02', kicker: 'DURACIÓN', title: 'Duración y ritmo',
    blocks: [
      { type: 'text', content: 'El programa va de agosto 2026 a agosto 2027. Una sesión al mes. Entre 60 y 90 minutos.' },
      { type: 'list', items: [
        'La mentee agenda. Es su proceso y su iniciativa.',
        'Si una sesión se cae, se reagenda dentro de la misma quincena. No se pierde.',
        'Ambos se comprometen a llegar hasta la sesión de cierre, en agosto 2027.',
      ] },
      { type: 'text', content: 'Llega a la hora, llega preparado, y registra la sesión en la plataforma.' },
    ],
  },
  {
    id: 'p3', num: '03', kicker: 'CONFIDENCIALIDAD', title: 'Confidencialidad',
    blocks: [
      { type: 'text', content: 'Lo conversado en sesión queda entre ustedes dos.' },
      { type: 'list', items: [
        'La bitácora del mentee es privada. No la ven los organizadores del programa ni ninguna persona del equipo de Mitsui.',
        'El patrocinador de Recursos Humanos ve participación y avance —sesiones realizadas, porcentaje de progreso, valoración del programa—. Nunca contenido.',
      ] },
    ],
  },
];

export const MENTEE_QUESTIONS: AgreementQuestion[] = [
  { id: 'q1', text: '¿Qué me comprometo a aportar a este proceso?', helper: 'Mi tiempo real, mi honestidad sobre lo que no sé, mi voluntad de incomodarme, mi seguimiento entre sesiones.' },
  { id: 'q2', text: '¿Cómo le voy a decir a mi mentor cuando algo no esté funcionando?', helper: 'Acuerdo explícito de feedback directo — ¿en sesión? ¿por escrito? ¿en cualquier momento?' },
  { id: 'q3', text: '¿Qué espero de mi mentor en este proceso?', helper: 'Honestidad aunque incomode, espacio para pensar, retos, su red cuando sea útil.' },
  { id: 'q4', text: '¿Qué quiero ver en mí al cierre del programa?', helper: 'Lo que quiero ser capaz de hacer, decir o decidir que hoy aún no puedo.' },
  { id: 'q5', text: '¿Qué es lo que NO esperaré de mi mentor?', helper: 'Que me dé respuestas, que me valide siempre, que tome decisiones por mí, que esté disponible siempre.' },
  { id: 'q6', text: 'Mi compromiso personal con este programa:', helper: 'Una frase concreta — la leerás en voz alta en la primera sesión.' },
];

export const MENTOR_QUESTIONS: AgreementQuestion[] = [
  { id: 'q1', text: '¿Qué me comprometo a ofrecer como mentor?', helper: 'Mi tiempo real, mi honestidad aunque incomode, mis errores como aprendizaje, mi red cuando sea útil.' },
  { id: 'q2', text: '¿Cómo quiero que me digan si no estoy aportando?', helper: 'Acuerdo explícito de feedback directo — ¿en sesión? ¿por escrito? ¿en cualquier momento?' },
  { id: 'q3', text: '¿Qué le voy a pedir a cambio al mentee?', helper: 'Que llegue preparado, que sea vulnerable, que cumpla sus compromisos, que me diga cuando no le sirvo.' },
  { id: 'q4', text: '¿Qué visión tengo de este mentee? ¿Qué potencial veo?', helper: 'Lo que tú ves en el mentee que quizás él/ella aún no ve en sí mismo.' },
  { id: 'q5', text: '¿Qué es lo que NO haré como mentor?', helper: 'Darle las respuestas fáciles, proteger su imagen, juzgar sus decisiones, hablar de él/ella afuera.' },
  { id: 'q6', text: 'Mi compromiso personal con este programa:', helper: 'Una frase concreta — la leerás en voz alta en la primera sesión.' },
];

export const questionsFor = (role: string): AgreementQuestion[] =>
  role === 'mentor' ? MENTOR_QUESTIONS : MENTEE_QUESTIONS;
